<template>
  <div class="user_container">
    <div class="top_content">
      <div class="user_top1">
        <div class="header_con">
          <span>徽章博物馆</span>
        </div>
        <div class="content_list">
          <div
            class="list_item"
            v-for="(item, index) in badgeList"
            :key="index"
          >
            <div class="item_header">
              <div class="item_title">{{ item.medalTypeName }}</div>
            </div>
            <div class="item_con">
              <div
                class="badge_item"
                v-for="(badge, ind) in item.medals"
                :key="ind"
                @click="handleBadge(item, badge)"
              >
                <img :src="imgUrl + badge.iconId" alt="" />
                <div class="badge_tit">{{ badge.medalName }}</div>
                <!-- <div class="sub_tit">
                  {{ badge.light == 1 ? "已获得" : "未获得" }}
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      class="dialog"
      v-model="showTip"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog_header">
        <div></div>
        <div class="dialog_title">徽章赠送</div>
        <div>
          <van-icon name="cross" @click="handelNo" />
        </div>
      </div>
      <van-form label-width="70" label-align="right">
        <van-field
          v-model="form.cardName"
          name="卡片类型"
          label="卡片类型："
          placeholder="卡片类型"
          readonly
        />

        <van-field
          v-model="form.medalName"
          name="关键词"
          label="关键词："
          placeholder="请选择关键词"
        >
        </van-field>
        <van-field
          v-model="form.point"
          name="分值"
          label="分值："
          placeholder="分值"
          readonly
        />
        <van-field name="赠送人" label="赠送人：" placeholder="请输入赠送人">
          <template #input>
            <el-select
              v-model="form.reciverEmpno"
              placeholder="请输入赠送名字"
              clearable
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select"
              @blur.native.capture="onblur"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
              @change="handleReciverEmpno"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <van-field name="抄送人" label="抄送人：" placeholder="抄送人">
          <template #input>
            <el-select
              v-model="form.ccEmpno"
              placeholder="请选择抄送人"
              multiple
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select2"
              @blur.native.capture="onblur2"
              @hook:mounted="cancalReadOnly2"
              @visible-change="cancalReadOnly2"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <div class="dialog-reason">
          <div>
            <van-field
              v-model="form.reason"
              rows="2"
              autosize
              label="赠送理由："
              type="textarea"
              maxlength="200"
              placeholder="请输入赠送理由"
              show-word-limit
            />
          </div>
        </div>
      </van-form>

      <div class="dialog-btn">
        <el-button @click="handelNo">取消</el-button>
        <el-button
          @click="handelOk"
          style="background: rgba(72, 158, 108, 1); color: #fff"
          :disabled="isDisabled"
          v-loading="isDisabled"
          >确认</el-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/cookie";
import api from "@/apis/medal";
import apiLogin from "@/apis";
export default {
  name: "badgeList",
  props: {},

  data() {
    return {
      badgeList: [],
      imgUrl: "",
      showTip: false,
      form: {
        cardName: "",
        cardId: "",
        point: "",
        senderEmpno: "",
        reciverEmpno: "",
        ccEmpno: [],
        medalId: "",
        medalName: ""
      },
      isDisabled: false,
      loadingSelect: false,
      options: []
    };
  },

  created() {},
  computed: {},
  mounted() {
    this.imgUrl = api.imgUrl;
    let hrToken = getToken();
    //获取token
    if (hrToken) {
      this.empno = hrToken;
      this.queryMedalCardAll(hrToken);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.queryMedalCardAll(res);
        });
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取徽章列表
    queryMedalCardAll(empno) {
      api.medalCardAllApi({ empno }).then(res => {
        if (res.code == 200) {
          this.badgeList = res.data;
        }
      });
    },
    //点击徽章，消息提示
    handleBadge(item, badge) {
      if (badge.flagType == 2) {
        return this.$message({
          message: "该徽章只能系统赠送",
          type: "warning"
        });
      } else if (badge.flagType == 3) {
        return this.$message({
          message: "该徽章此处无法赠送",
          type: "warning"
        });
        // if (this.$store.state.userInfo.hr == 1) {
        //   this.form.cardName = item.medalTypeName;
        //   this.form.medalName = badge.medalName;
        //   this.form.medalId = badge.id;
        //   this.form.point = badge.point;
        //   this.showTip = true;
        // } else {
        //   return this.$message({
        //     message: "对不起，该徽章您没有权限赠送",
        //     type: "warning"
        //   });
        // }
      } else {
        this.form.cardName = item.medalTypeName;
        this.form.medalName = badge.medalName;
        this.form.medalId = badge.id;
        this.form.point = badge.point;
        this.showTip = true;
      }
    },
    //返回
    goBack() {
      this.$router.back();
    },
    //取消赠送
    handelNo() {
      this.showTip = false;
      this.form = {};
    },
    //确认赠送
    handelOk() {
      if (!this.form.medalId) {
        return this.$message({
          message: "请选择关键词",
          type: "warning"
        });
      }
      if (!this.form.reciverEmpno) {
        return this.$message({
          message: "请选择赠与人",
          type: "warning"
        });
      }
      if (!this.form.reason) {
        return this.$message({
          message: "请输入赠送理由",
          type: "warning"
        });
      }
      this.isDisabled = true;
      const json = {
        medalId: this.form.medalId,
        receiverEmpno: this.form.reciverEmpno,
        ccEmpno: this.form.ccEmpno.join(","),
        reason: this.form.reason,
        senderEmpno: this.$store.state.userInfo.username,
        cardId: this.$route.query.id
      };
      api.medalCardSendApi(json).then(res => {
        if (res.code == 200) {
          this.showTip = false;
          this.$message({
            message: "赠送成功",
            type: "success"
          });
          this.$router.back();
        }
        this.isDisabled = false;
      }).catch(() => {
        this.isDisabled=false
      });
    },
    // 查询 抄送人
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value
        })
        .then(data => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },

    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //限制不能给自己赠送徽章
    handleReciverEmpno(value) {
      if (this.empno == value) {
        this.form.reciverEmpno=''
        return this.$message({
          message: "不能给自己赠送徽章",
          type: "warning"
        });
      }
    },
    // 在苹果手机上唤起键盘
    onblur2() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select2.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly2(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select2 } = this.$refs;
          const input = select2?.$el.querySelector(".el-input__inner");
          input?.removeAttribute("readonly");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #f7f9fa;

  .user_top1 {
    background-image: url("~@/assets/newsNotice/background3.png");
    background-size: 100% 100%;
    height: 100vh;
    .header_con {
      height: 150px;
      line-height: 150px;
      font-weight: bold;
      font-size: 34px;
      color: #282b32;
      text-align: center;
    }
  }
  .content_list {
    width: 100%;
    height: calc(100vh - 150px);
    overflow-y: auto;
    position: absolute;
    top: 150px;
    padding: 0 30px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0px -3px 7px 0px rgba(0, 0, 0, 0.04);
    border-radius: 54px 54px 0px 0px;
    &::-webkit-scrollbar {
      display: none;
    }
    .list_item {
      .item_header {
      }
      .item_title {
        font-weight: 600;
        font-size: 29px;
        color: #282b32;
        margin: 40px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        &::before {
          content: "";
          display: inline-block;
          width: 38px;
          height: 18px;
          background-image: url("~@/assets/newsNotice/icon12.png");
          background-size: 100% 100%;
          margin-right: 20px;
        }
        &::after {
          content: "";
          display: inline-block;
          width: 38px;
          height: 18px;
          background-image: url("~@/assets/newsNotice/icon13.png");
          background-size: 100% 100%;
          margin-left: 20px;
        }
      }
      .item_con {
        display: flex;
        flex-wrap: wrap;
        .badge_item {
          width: 33.33%;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 50px;
          img {
            width: 146px;
            height: 146px;
          }
          .badge_tit {
            font-weight: 500;
            font-size: 27px;
            color: #191b28;
            margin: 10px 0;
          }
          .sub_tit {
            font-weight: 400;
            font-size: 22px;
            color: #999999;
          }
        }
      }
    }
  }
}
.dialog {
  // height: 218px * $zoom;
  padding: 30px;
  .dialog_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 32px;
    color: #282b32;
  }

  .dialog-people {
    margin-bottom: 30px;
  }
  ::v-deep {
    .van-cell::after {
      border: 0;
    }
    .el-input__inner {
      border: 0;
      background: #f7f9fa;
      border-radius: 10px;
    }
  }
  .dialog-reason {
    ::v-deep {
      .van-cell {
        // background: rgba(244, 244, 244, 1);
        display: flex;
        flex-direction: column;
      }

      .van-field__control {
        // height: 200px !important;
      }
      .van-field__value {
        background: rgba(244, 244, 244, 1);
        padding: 20px 20px;
        border-radius: 10px;
        margin-top: 20px;
      }
    }
  }

  ::v-deep {
    .el-input__inner {
      min-height: 22px * $zoom !important;
    }
  }

  .cc {
    ::v-deep {
      .el-select__tags {
        max-width: none !important;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 200px;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
